import React from "react";
import injectSheet from "react-jss";
import clsx from "clsx";
import { DragSource } from "react-dnd";

const imageSource = {
  beginDrag(props) {
    return {
      id: props.image.id,
    };
  },

  endDrag(props, monitor) {
    if (monitor.didDrop()) {
      const { image, onAddImage } = props;

      let { x, y } = monitor.getDropResult();
      onAddImage({ ...image, x, y });
    }
  },
  canDrag(props) {
    return props.disabled !== true;
  },
};

class ImageListImage extends React.Component {
  render() {
    const { classes, image, connectDragSource, disabled } = this.props;
    return connectDragSource(
      <div
        className={clsx(classes.image, {
          [classes.disabled]: disabled,
        })}
      >
        {image.name.length > 0 && (
          <div className={classes.name}>{image.name}</div>
        )}
        <img src={image.urls.low} alt="" loading="lazy" />
      </div>,
    );
  }
}

const styles = theme => ({
  image: {
    flex: 0,
    minWidth: "100%",
    transitionDuration: theme.transitionDuration,
    transitionProperty: "transform",
    cursor: "move",
    border: `1px solid ${theme.colorGrey}`,
    borderRadius: 4,
    marginBottom: theme.spacing2,
    backgroundColor: theme.colorBackground,
    padding: theme.spacing2,
    boxSizing: "border-box",
    lineHeight: 0,

    "& img": {
      borderRadius: 4,
      width: "100%",
      objectFit: "cover",
      objectPosition: "top",
      height: 113,
      pointerEvents: "none",
    },

    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  name: {
    textAlign: "left",
    color: theme.textColor,
    paddingBottom: theme.spacing2,
    lineHeight: "1rem",
  },
  disabled: {
    opacity: 0.5,
    "&:hover": {
      cursor: "not-allowed",
      transform: "scale(1)",
    },
  },
});

export default DragSource("new-image", imageSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
}))(injectSheet(styles)(ImageListImage));
